<template>
    <b-button
        icon-left="eye"
        @click.prevent="showModal()"
    >
        View PDF
    </b-button>
</template>

<script>
import DocumentModal from './DocumentModal';

export default {
    props: {
        document: {
            type: Object,
            required: true,
        },
    },

    methods: {
        showModal() {
            this.$buefy.modal.open({
                parent: this,
                component: DocumentModal,
                hasModalCard: true,
                fullScreen: true,
                props: {
                    document: this.document,
                },
            });
        },
    },
};
</script>
